var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHearts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(45,300,300)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 150,
    height: 350,
    width: 350
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 325,
    r: 175
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325,
    cy: 150,
    r: 175
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHearts);
export default __webpack_public_path__ + "static/media/hearts.3f28a229bdabce082f86bc5cf9556fca.svg";
export { ForwardRef as ReactComponent };